<template>
   <div>
      <view315Title :showBackIcon="showBackIcon" @backEvent="backEvent" :showExamBtn="showExamBtn" :title="title"></view315Title>
   </div>
   <div class="main" id="dialog">
      <!-- 考试通过 -->
      <div v-if="showSucc">
         <div class="main_img">
            <img :src="success" />
         </div>
         <div class="succ_info">
            <div>考试通过</div>
            <div>恭喜，您可以开始采集任务啦！</div>
         </div>
      </div>
      <!-- 考试不通过 -->
      <div v-if="!showSucc">
         <div class="main_img">
            <img :src="error" />
         </div>
         <div class="error_info">
            <div>考试不通过</div>
            <div>您共完成{{ qidTotal }}题，做错{{ answerWrongCnt }}题，做对{{ answerRightCnt }}题</div>
            <div>很抱歉，您暂时还不能采集任务噢！</div>
         </div>
      </div>
      <div class="bottom_btn"><view315BtnVue @clickBtnEvent="clickBtnEvent" :showTwoBtn="showTwoBtn" :oneBtnName="oneBtnName" :userSelectEnd="userSelectEnd" :twoBtnName="twoBtnName"></view315BtnVue></div>
   </div>
    <nut-dialog
        v-model:visible="$store.state.examreslutVisible"
        teleport="#dialog"
        title="是否退出考试？"
        textAlign="left"
        :cancelAutoClose="false"
        okText="取消"
        cancelText="退出"
        :onOk="dialogOk"
        :onCancel="dialogCancle"
    >
      <div class="dialog_info">退出仍将保留当前考试结果。</div>
    </nut-dialog>

</template>
<script>
import view315Title from '@/components/view315Title'
import view315BtnVue from '../components/view315Btn.vue';
import { defineComponent, onBeforeMount, toRefs } from 'vue';
import { success, error } from './config'
import wx from 'weixin-js-sdk';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default defineComponent({
    setup(){
        const router = useRouter()
        const route = useRoute()
        const store = useStore()
        const data = {

            showExamBtn: false, //不展示导航最右边按钮
            showBackIcon: true, // 展示返回按钮
            showSucc: true, // 是否通过
            showTwoBtn: true, //是否展示两个按钮
            title: '考试结果', // （通过与不通过）

            qidTotal: 0, // 总体数
            answerWrongCnt: 0, // 错题数
            answerRightCnt: 0, //对题数

            success, // 通过icon
            error, // 不通过icon

            oneBtnName: '', // 第一个按钮的名称
            twoBtnName: '', // 第二个按钮的名称
            userSelectEnd: true, // 高亮第二个按钮

            

        }
        onBeforeMount(() => {
            if(route.query.obj){
                let { qidTotal, answerWrongCnt, answerRightCnt } = JSON.parse(route.query.obj)
                data.qidTotal = qidTotal
                data.answerWrongCnt = answerWrongCnt
                data.answerRightCnt = answerRightCnt
            }
            if(data.answerRightCnt == data.qidTotal){
                data.showSucc = true
                data.oneBtnName = '查看答案'
                data.twoBtnName = '开始采集' 
            }else{
                data.showSucc = false
                data.oneBtnName = '查看错题' 
                data.twoBtnName = '重新考试' 
            }
            data.showBackIcon = !store.state.isH5;
        })
        // 点击三角返回
        const backEvent = () => {
            // 触发客户端返回操作
            // 通过
            if(data.qidTotal == data.answerRightCnt){
                /* eslint-disable */
                // javascript:android.close()
                window.easyearn.close()
                /* eslint-enable */
            }
            // 不同过
            else if(data.qidTotal !== data.answerRightCnt){
                store.dispatch('setExamreslutvisible', true)
            }
        }

        // onMounted(() => {
        //     onpopstate()
        // })
        // onUnmounted(() =>{
        //     window.removeEventListener("popstate", backEvent, false);
        // })
        // // 监听物理返回
        // const onpopstate =  () => {
        //     pushHistory()
        //     // 给window添加一个popstate事件，拦截返回键，执行backClientMap事件，addEventListener需要指向一个方法
        //     window.addEventListener("popstate", backEvent, false);
        // }
        
        // 推出
        const dialogCancle = () => {
            store.dispatch('setExamreslutvisible', false)
            /* eslint-disable */
            // javascript:android.close()
            store.state.isH5 ? wx.miniProgram.navigateBack() : window.easyearn.close()
            /* eslint-enable */
        }
        // 取消推出
        const dialogOk = () => {
            store.dispatch('setExamreslutvisible', false)
        }
        // 点击按钮以及返回按钮
        const clickBtnEvent = (type) => {
            // 没通过
            if(data.showSucc == false){
                if(type == "next"){
                    // 重新考试
                    router.push({
                        path: '/examination',
                        query: {
                            examId: sessionStorage.getItem('examId'),
                            previewBtn: store.state.previewBtn
                        }
                    })
                }else{
                    //  查看错题
                    router.push({ 
                        path: '/examination', 
                        query: { 
                            examBtnTitle: '全部题目',
                            examId: sessionStorage.getItem('examId'),
                            previewBtn: store.state.previewBtn
                        } 
                    })
                }
            }else{
                // 通过
                if(type == "next"){
                    console.log(wx.miniProgram, 'wx.miniProgram');
                    // 开始采集
                    /* eslint-disable */
                    // javascript:android.startCollect()
                    store.state.isH5 ? wx.miniProgram.switchTab({
                        url: '/pages/userHomePagenew/userHomePagenew'
                    }) : window.easyearn.startCollect()
                    /* eslint-enable */
                }else{
                    //  查看答案
                    router.push({ 
                        path: '/examination', 
                        query: { 
                            examBtnTitle: '',
                            examId: sessionStorage.getItem('examId'),
                            previewBtn: store.state.previewBtn
                        } 
                    })
                }
            }
        }
        return {
            ...toRefs(data),
            clickBtnEvent,
            backEvent,
            dialogOk,
            dialogCancle,
        }
    },
    components:{
        view315Title,
        view315BtnVue
    }
})
</script>
<style lang='scss' scoped>
.main{
   margin: 0 auto;
   background-color: #fff;
   width: 100%;
   flex: auto;
   padding-top: 40px;
}
#dialog{
    background: #fff;
    & :deep(.nut-dialog){
        width: 320px;
        box-sizing: border-box;
        padding: 30px 20px 20px;
    }
    & :deep(.nut-dialog__header){
        text-align: left;
        font-weight: Bold;
        font-size: 16Px;
        line-height: 16Px;
    }
    & :deep(.nut-dialog__content){
        margin: 4px 0;
        max-height: 21px;
        min-height: 21px;
    }
    & :deep(.nut-dialog__footer){
        margin-top: 30px;
        max-height: 42px;
        min-height: 42px;
        display: block;
        text-align: right;
    }
    & :deep(.nut-dialog__footer-cancel){
        margin: 0;
        color: #0088FF;
        border: none;
        margin-right: 30px;
        height: 16px;
        font-weight: Bold;
        font-size: 16Px;
        text-align: center;
        line-height: 16Px;
    }
    & :deep(.nut-dialog__footer-ok){
        width: 104px;
        height: 42px;
        background: #0088FF;
        border-radius: 21px;
        font-weight: Bold;
        font-size: 16Px;
        color: #fff;
        text-align: center;
        line-height: 16Px;
    }
}

.main_img{
   text-align: center;
   & img{
      width: 48px;
      height: 48px;
   }
}
.succ_info{
   & :nth-child(1){
      // width: 80px;
      height: 22px;
      opacity: 0.9;
      // font-family: NotoSansCJKsc-Bold;
      font-weight: Bold;
      font-size: 16Px;
      text-align: center;
      line-height: 22px;
      margin-top: 12px;
   }
   & :nth-child(2){
      // width: 168px;
      height: 12px;
      opacity: 0.7;
      // font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 12Px;
      text-align: center;
      line-height: 12px;
      margin-top: 12px;
   }
}
.error_info{
   & :nth-child(1){
      // width: 80px;
      height: 22px;
      opacity: 0.9;
      // font-family: NotoSansCJKsc-Bold;
      font-weight: Bold;
      font-size: 16Px;
      text-align: center;
      line-height: 22px;
      margin-top: 12px;
   }
   & :nth-child(2){
      // width: 184px;
      height: 12px;
      opacity: 0.7;
      // font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 12Px;
      line-height: 12px;
      text-align: center;
      margin: 8px 0 4px;
   }
   & :nth-child(3){
      // width: 192px;
      height: 12px;
      opacity: 0.7;
      // font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 12Px;
      text-align: center;
      line-height: 12px;
      margin-top: 8px;
   }
}
.bottom_btn{
   position: fixed;
   bottom: 19px;
   width: 100%;
    // height: 42px;
}
</style>